"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileLibraryProvider = void 0;
var FileLibraryProvider;
(function (FileLibraryProvider) {
    FileLibraryProvider[FileLibraryProvider["Club"] = 1] = "Club";
    FileLibraryProvider[FileLibraryProvider["PlayerBackoffice"] = 2] = "PlayerBackoffice";
})(FileLibraryProvider || (exports.FileLibraryProvider = FileLibraryProvider = {}));
